// Structured data for SEO
export const getOrganizationStructuredData = () => ({
  "@context": "https://schema.org",
  "@type": "Person",
  "name": "आचार्य अभिषेक पांडेय",
  "alternateName": "Acharya Abhishek Pandey",
  "description": "प्रामाणिक ज्योतिष और तंत्र विशेषज्ञ, 15+ वर्षों का अनुभव",
  "url": "https://acharyaabhishekpandey.com",
  "telephone": "+91-98765-43210",
  "email": "info@acharyaabhishek.com",
  "address": {
    "@type": "PostalAddress",
    "addressLocality": "New Delhi",
    "addressCountry": "India",
    "addressRegion": "Delhi"
  },
  "sameAs": [
    "https://facebook.com/acharyaabhishekpandey",
    "https://instagram.com/acharyaabhishekpandey",
    "https://twitter.com/acharyaabhishek"
  ],
  "jobTitle": "Astrologer and Tantra Expert",
  "worksFor": {
    "@type": "Organization",
    "name": "आचार्य अभिषेक पांडेय"
  },
  "expertise": [
    "Vedic Astrology",
    "Tantra and Mantra",
    "Gemstone Therapy",
    "Puja and Rituals",
    "Vashikaran",
    "Black Magic Removal"
  ],
  "knowsAbout": [
    "ज्योतिष शास्त्र",
    "तंत्र-मंत्र",
    "रत्न चिकित्सा",
    "पूजा-पाठ",
    "वशीकरण",
    "काला जादू निवारण"
  ]
});

export const getLocalBusinessStructuredData = () => ({
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "आचार्य अभिषेक पांडेय - Acharya Abhishek Pandey",
  "image": "https://acharyaabhishekpandey.com/images/acharya-profile.jpg",
  "description": "प्रामाणिक ज्योतिष और तंत्र विशेषज्ञ। सभी प्रकार की पूजा, कुंडली विश्लेषण, तांत्रिक समाधान और रत्न उपचार की सेवा।",
  "url": "https://acharyaabhishekpandey.com",
  "telephone": "+91-98765-43210",
  "email": "info@acharyaabhishek.com",
  "address": {
    "@type": "PostalAddress",
    "addressLocality": "New Delhi",
    "addressCountry": "India",
    "addressRegion": "Delhi"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": 28.6139,
    "longitude": 77.2090
  },
  "openingHours": "Mo-Su 00:00-23:59",
  "priceRange": "₹₹",
  "serviceArea": {
    "@type": "Country",
    "name": "India"
  },
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Astrology and Tantra Services",
    "itemListElement": [
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "ज्योतिष परामर्श - Astrology Consultation",
          "description": "कुंडली विश्लेषण और भविष्यवाणी"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "तांत्रिक समाधान - Tantrik Solutions",
          "description": "जादू टोना निवारण और वशीकरण"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "पूजा पाठ - Puja Services",
          "description": "सभी प्रकार की धार्मिक पूजा"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "रत्न चिकित्सा - Gemstone Therapy",
          "description": "प्रमाणित रत्नों की सेवा"
        }
      }
    ]
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.8",
    "reviewCount": "500",
    "bestRating": "5",
    "worstRating": "1"
  }
});

export const getServiceStructuredData = (serviceName, description, price) => ({
  "@context": "https://schema.org",
  "@type": "Service",
  "name": serviceName,
  "description": description,
  "provider": {
    "@type": "Person",
    "name": "आचार्य अभिषेक पांडेय",
    "telephone": "+91-98765-43210",
    "email": "info@acharyaabhishek.com"
  },
  "areaServed": {
    "@type": "Country",
    "name": "India"
  },
  "availableChannel": {
    "@type": "ServiceChannel",
    "serviceUrl": "https://acharyaabhishekpandey.com",
    "servicePhone": "+91-98765-43210"
  },
  "category": "Astrology and Spiritual Services",
  "offers": {
    "@type": "Offer",
    "price": price,
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock"
  }
});

export const getBreadcrumbStructuredData = (breadcrumbs) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": breadcrumbs.map((breadcrumb, index) => ({
    "@type": "ListItem",
    "position": index + 1,
    "name": breadcrumb.name,
    "item": breadcrumb.url
  }))
});

export const getFAQStructuredData = (faqs) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": faqs.map(faq => ({
    "@type": "Question",
    "name": faq.question,
    "acceptedAnswer": {
      "@type": "Answer",
      "text": faq.answer
    }
  }))
});